import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Paper, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Logo from "./large.png";
import Back from "./back.svg";
import { Button, TextField, Divider } from "@mui/material";
import useSave from "../../Hooks/useSave";

const Img = styled.img`
  height: 150px;
  width: auto;
`;

export default function CreatePassword() {
  const { token } = useParams();
  const [loginCredentials, setLoginCredentials] = useState({});
  const { fetchGraphql, DialogSave } = useSave();
  const navigate = useNavigate();

  const handleChange = (e, type) => {
    const copyState = { ...loginCredentials };

    switch (type) {
      case "email":
        copyState.email = e.target.value;
        break;
      case "password":
        copyState.password = e.target.value;
        break;
      case "rePassword":
        copyState.rePassword = e.target.value;
        break;
      default:
    }

    setLoginCredentials(copyState);
  };

  const handlePasswordDiffernce = () => {
    const isSame = loginCredentials.password === loginCredentials.rePassword;

    return isSame;
  };

  const handleLogin = () => {
    if (!handlePasswordDiffernce()) {
      return alert(
        "The passwords you entered does not match - pleases make sure they match before you submit"
      );
    } else if (loginCredentials.email.length < 7) {
      alert(
        "Your username is too short - Please enter a username that is more then 7 characters long"
      );
    } else {
      // console.log("were");
      window.localStorage.setItem("token", token);

      fetchGraphql({
        query: `mutation CreateLoginCredentials($email: String!, $password: String!, $token: String!) {
          createLoginCredentials(email: $email, password: $password, token: $token)
        }`,
        variables: {
          email: loginCredentials.email,
          password: loginCredentials.password,
          token,
        },
      }).then((result) =>
        result.data.createLoginCredentials ? navigate("/") : null
      );
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: `url(${Back})`,
        backgroundSize: "cover",
        backgroundColor: "rgb(156, 39, 176, .1)",
      }}
    >
      <DialogSave />
      <Typography>Please create a Username and password</Typography>
      <Paper
        sx={{
          height: "500px",
          width: "350px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-evenly",
          boxShadow: "0px 0px 4px 2px rgba(0, 0, 0, 0.2)",
        }}
      >
        <Img src={Logo} />
        <Box
          sx={{
            borderBottom: "solid 1px rgba(0, 0, 0, 0.2)",
            padding: "0px 40px 15px 40px",
          }}
        >
          <Typography>Username</Typography>
          <TextField
            variant="outlined"
            // type="password"
            value={loginCredentials.email}
            onBlur={() => {
              if (loginCredentials.email.length < 7) {
                alert(
                  "Your username is too short - Please enter a username that is more then 7 characters long"
                );
                return;
              }
            }}
            onPaste={(e) => e.preventDefault()}
            // onKeyUp={(e) => login(e)}
            onChange={(e) => handleChange(e, "email")}
          />
        </Box>

        <Box>
          <Typography>Password</Typography>
          <TextField
            variant="outlined"
            type="password"
            value={loginCredentials.password}
            onPaste={(e) => e.preventDefault()}
            // onKeyUp={(e) => login(e)}
            onChange={(e) => handleChange(e, "password")}
          />
        </Box>

        <Box>
          <Typography>Re-enter Password</Typography>
          <TextField
            variant="outlined"
            type="password"
            value={loginCredentials.rePassword}
            onPaste={(e) => e.preventDefault()}
            onBlur={() => {
              if (handlePasswordDiffernce()) {
                return;
              } else {
                alert(
                  "The passwords you entered does not match - pleases make sure they match before you submit"
                );
              }
            }}
            // onKeyUp={(e) => login(e)}
            onChange={(e) => handleChange(e, "rePassword")}
          />
        </Box>

        <Button variant="contained" onClick={handleLogin}>
          Create Password
        </Button>
      </Paper>
    </Box>
  );
}
